<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      scrollable
      :overlay-opacity="0.7"
      :retain-focus="false"
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="white" elevation="0" class="content-header">
          <v-btn icon plain :ripple="false"
                 class="btn-page-prev"
                 @click="close()">
            <IconBack/>
          </v-btn>
          <v-toolbar-title>배송지정보</v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form class="form-item" v-model="valid">
          <label class="label">수령인</label>
          <div class="input-group">
            <v-text-field solo flat filled
                          v-model="po.recipient"
                          required
                          placeholder="이름"
            />
          </div>
          <label class="label">휴대전화</label>
          <div class="input-group">
            <v-text-field solo flat filled
                          v-model="po.mobileNo"
                          :roles="mobile_rule"
                          required
                          maxlength="11"
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                          @keydown.space.prevent
                          placeholder="01012345678"/>
          </div>
          <label class="label">배송지 주소</label>
          <div class="input-group mb-3">
            <v-text-field solo flat filled
                          hide-details="true"
                          v-model="po.addressFirst"
                          required
                          readonly
                          placeholder="주소를 검색해 주세요"
            />
            <v-btn depressed :ripple="false" color="primary" class="btn-input" width="90"
                   @click="showApi">주소검색
            </v-btn>
          </div>
          <div class="input-group">
            <v-text-field solo flat filled
                          v-model="po.addressSecond"
                          required
                          placeholder="상세 주소를 입력해 주세요"
            />
          </div>
          <label class="label">공동현관 출입방법</label>
          <div class="input-group">
            <v-text-field append-icon="mdi-menu-down" solo flat filled v-model="po.enterMethodCd" readonly
                          placeholder="공동현관 출입방법을 선택해주세요" @click="rollerPickerOpen"/>
          </div>
          <v-textarea
              filled
              solo
              flat
              background-color="#F7F7F7"
              no-resize
              placeholder="특수문자, 기호등을 포함해 비밀번호를 정확히 입력해주세요."
              class="pa-0 textarea"
              style="margin-top: -18px;"
              hide-details="true"
              v-model="po.enterMethodMemo"
              v-if="po.enterMethodCd === '기타'"
          ></v-textarea>
          <div v-if="po.requestCd === '기타'" class="info--text fs-12 mt-2 mb-6">비밀번호가 정확하지 않을 경우 공동 현관 혹은 경비실 앞에 배송 될 수
            있습니다.
          </div>
          <label class="label">배송시 요청사항</label>
          <div class="input-group">
            <v-text-field solo flat filled append-icon="mdi-menu-down" v-model="po.requestCd" readonly
                          placeholder="요청사항을 선택해주세요" @click="rollerPickerOpen2"/>
          </div>
          <v-textarea
              filled
              solo
              flat
              background-color="#F7F7F7"
              no-resize
              placeholder="내용을 입력해주세요."
              class="pa-0 textarea"
              style="margin-top: -18px;"
              v-model="po.requestMemo"
              v-if="po.requestCd === '기타'"
          ></v-textarea>
          <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue"/>
          <DaumKakaoAddressModal ref="DaumKakaoAddressModal" @callback="returnAddress"/>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <BlackBtn x-large :str="btnStr" :disabled="false" @click="register"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IconBack from '@/components/icons/Back'
import BlackBtn from "@/components/btns/BlackBtn";
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import store from '@/store'
import DaumKakaoAddressModal from "../../components/layout/DaumKakaoAddressModal.vue";

export default {
  components: {
    IconBack,
    BlackBtn,
    SelectRollerPicker,
    DaumKakaoAddressModal
  },
  props: {
    daNo: {
      type: Number,
      default: null
    },
    name: String,
    mobileNo: String
  },
  data: () => ({
    dialog: false,
    confirmDialog: false,
    iframe: {
      src: 'http://localhost:8081/user/fo/deliveryAddress',
      style: 'border:none; vertical-align: top;',
      scrolling: 'yes'
    },
    valid: false,
    po: {
      recipient: '',
      mobileNo: '',
      addressFirst: '',
      addressSecond: '',
      enterMethodCd: '',
      enterMethodMemo: '',
      requestCd: '',
      requestMemo: ''
    },
    items: ['부재중시 경비실에 맡겨주세요', '기타'],

    items2: ['현관 앞에 놓아 주세요.', '부재시 경비실에 맡겨 주세요.', '무인 택배함에 넣어주세요.', '부재시 휴대 전화로 연락주세요.', '기타'],
    searchSheet: false,
    btnStr: null,
    confirmStr: null
  }),
  mounted() {
    window.closeModal = this.close()
  },
  watch: {
    async dialog() {
      if (this.dialog) {
        this.findAddressDetail();
      }
      if (this.daNo === null) {
        this.btnStr = '등록하기'
        this.confirmStr = '등록하시겠습니까?'
      } else {
        this.btnStr = '수정하기'
        this.confirmStr = '수정하시겠습니까?'
      }
    }
  },
  computed: {
    mobile_rule() {
      return [
        v => !!v || '휴대폰번호를 입력해주세요.'
        , v => !(v && v.length < 11) || '-(하이픈) 제외, 숫자만 입력해주세요.'
        , v => /^\D/g.test(v) || '숫자만 입력 가능합니다.',
      ]
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    async register() {
      if (this.po.recipient === null && this.po.recipient === "") {
        this.$alert("수령인을 입력해 주세요.");
        return false;
      }

      if (this.po.mobileNo === null && this.po.mobileNo === "") {
        this.$alert("휴대폰번호를 입력해 주세요.");
        return false;
      }
      if (this.po.addressFirst === null && this.po.addressFirst === "") {
        this.$alert("주소를 입력해 주세요.");
        return false;
      }

      if (this.po.enterMethodCd === "기타" && (this.po.enterMethodMemo === "" || this.po.enterMethodMemo === null)) {
        this.$alert("공동현관 출입방법을 입력해 주세요.");
        return false;
      }

      if (this.po.requestCd === "기타" && (this.po.requestMemo === "" || this.po.requestMemo === null)) {
        this.$alert("배송시 요청사항을 입력해 주세요.");
        return false;
      }


      this.$confirm(this.confirmStr).then(result => {
        if (result) {
          store.dispatch('addDeliveryAddress', this.$_payload('po', this.po))
            .then(res => {
              if (res.code === '000') {
                this.$alert("등록되었습니다.");
              }
              this.$emit("callback");
              this.close();
            })
            .catch(error => {
              console.error(error)


            })
            .finally(() => {

            })
          this.close()
        }
      })
    },
    rollerPickerOpen() {
      this.selectFlag = 1;
      this.$refs.rollerPicker.setFlicking(this.items);
    },
    rollerPickerOpen2() {
      this.selectFlag = 2;
      this.$refs.rollerPicker.setFlicking(this.items2);
    },
    selectValue(value) {
      if (this.selectFlag === 1) {
        this.po.enterMethodCd = value;
      } else {
        this.po.requestCd = value;
      }
      this.selectFlag = 0;
    },
    showApi() {
      this.$refs.DaumKakaoAddressModal.open();
    },
    returnAddress(data) {
      console.log(data);
      this.po.addressFirst = data
    },
    async findAddressDetail() {
      await store.dispatch('deliveryAddress', this.$_payload("so", {}))
        .then(res => {
          if (res.data !== null) {
            this.po = res.data
            this.$emit("callback");
          } else {
            this.po.recipient = this.name;
            this.po.mobileNo = this.mobileNo.replaceAll('-', '');
          }
        })
        .catch(error => {
          console.error(error)


        })
        .finally(() => {

        })
    }
  }
}
window.addEventListener("message", function (eve) {
  // console.log(eve.data)
  if (eve.data.params == 'close') {
    window.closeModal();
  }
});
</script>

<style lang="scss" scoped>
::v-deep.v-btn.btn-close {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #fff;
}

::v-deep.v-btn.btn-guide {
  position: absolute;
  top: 15px;
  right: 23px;
}
</style>
